import React, { useState, useRef, useEffect } from "react";
import ReactCrop, {
    centerCrop,
    makeAspectCrop,
} from "react-image-crop";
import { Skeleton, Typography } from "@mui/material";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";
import "react-image-crop/dist/ReactCrop.css";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import EditIcon from "@mui/icons-material/Edit";
import CourseVector from '../../../Assets/Images/courseVector.png'
import CheckIcon from "@mui/icons-material/Check";
import { Span } from "../../CourseCreationFlow/styles";
import { styles } from "./styles";


function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: "%",
                width: 90,
            },
            aspect,
            mediaWidth,
            mediaHeight
        ),
        mediaWidth,
        mediaHeight
    );
}

export function ImageCropComponent({ setCroppedImage, courseImageUrl, formik, croppedImage }) {
    const MAX_WIDTH = 1920
    const MAX_HEIGHT = 1080
    const imgRef = useRef(null);
    const [crop, setCrop] = useState();
    const previewCanvasRef = useRef(null);
    const [error, setError] = useState("")
    const handleOpen = () => setOpen(true);
    const [imgSrc, setImgSrc] = useState("");
    const [fileName, setFileName] = useState("");
    const [open, setOpen] = React.useState(false);
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [completedCrop, setCompletedCrop] = useState();
    const aspect = 16 / 9
    const handleClose = () => {
        const base64String = previewCanvasRef.current?.toDataURL().split(',')[1];
        setCroppedImage(base64String);
        setOpen(false)
    };
    function onSelectFile(e) {
        setError("");
        setImgSrc("")
        setCrop(undefined)
        setCompletedCrop(undefined)
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const reader = new FileReader();
            setFileName(file ? file.name : "")
            reader.addEventListener("load", () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
                        setError(`Image exceeds max dimensions (${MAX_WIDTH}x${MAX_HEIGHT}px). Please select a smaller image.`);
                    } else {
                        setImgSrc(reader.result?.toString() || "")
                    }
                };
            });
            reader.readAsDataURL(file);
        }
    }

    function onImageLoad(e) {
        if (aspect) {
            const { width, height } = e.currentTarget;
            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                setError(`Image exceeds max dimensions (${MAX_WIDTH}x${MAX_HEIGHT}px). Please select a smaller image.`);
                setImgSrc("")
                return;
            }
            setCrop(centerAspectCrop(width, height, aspect));
        }
    }
    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                const base64String = previewCanvasRef.current.toDataURL().split(',')[1];
                setCroppedImage(base64String);
                canvasPreview(
                    imgRef.current,
                    previewCanvasRef.current,
                    completedCrop,
                );
            }
        },
        100,
        [completedCrop]
    );
    useEffect(() => {
        if (croppedImage) {
            formik.setFieldValue('courseImage', croppedImage);
        }
        // eslint-disable-next-line
    }, [croppedImage]);
    return (
        <>

            <Modal
                open={open}
                disableScrollLock
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...styles.modalBox, height: imgSrc ? 'auto' : 275}}>
                    <Box sx={styles.fileInputBox}>
                    {/* Hidden native input */}
                    <input id="fileUpload" type="file" accept="image/*" onChange={onSelectFile} style={{ display: "none" }} />
                    <label htmlFor="fileUpload" style={styles.fileLabel}>Choose File</label>
                    <Typography variant="body2" sx={styles.fileNameTypo}>
                        {!fileName && "no file selected"}
                    </Typography>

                    </Box>
                    {error && <Typography color="error" sx={styles.errorTypo}>{error}</Typography>}
                    {!!imgSrc && (
                        <ReactCrop crop={crop} onChange={(_, percentCrop) => setCrop(percentCrop)} onComplete={(c) => setCompletedCrop(c)} aspect={aspect}>
                            <img ref={imgRef} alt="Crop me" src={imgSrc} onLoad={onImageLoad} />
                        </ReactCrop>
                    )}
                    <Box sx={{...styles.checkBox, background:(theme) => theme.palette.primary.main}} onClick={handleClose}>
                    <Span>
                      <CheckIcon style={{ color: "#FFFFFF", cursor: "pointer  !important" }}  fontSize="large" />
                    </Span>
                    </Box>
                </Box>
            </Modal>
            <Box>
                <Box position="relative" height={200} width={{ xl: 375, sm: 390, md: 400, lg: 430 }}>
                    <Box sx={styles.editIconBox} onClick={handleOpen}>
                        <EditIcon fontSize="large" sx={{ color: (theme) => theme.palette.primary.main }} />
                    </Box>
                    {
                        completedCrop ? <>
                            {!!completedCrop && (
                                <Box>
                                    <canvas
                                        ref={previewCanvasRef}
                                        style={{
                                            border: "1px solid black",
                                            objectFit: "cover",
                                            width: "100%",
                                            height: 200,
                                        }}
                                    />
                                </Box>
                            )}
                        </> :
                            <Box
                                height={200}
                                width={{ xl: 375, sm: 390, md: 400, lg: 430 }}
                                >
                                {!imageLoaded && (
                                    <Skeleton
                                    variant="rectangular"
                                    width="100%"
                                    height="100%"
                                    />
                                )}
                                <img
                                    src={!imageError && courseImageUrl ? `${courseImageUrl}?t=${Date.now()}` : CourseVector}
                                    alt="Course"
                                    style={{ width: "100%", height: "100%", objectFit: "cover", display: imageLoaded ? "block" : "none" }}
                                    onLoad={() => setImageLoaded(true)}
                                    onError={(e) => {
                                    setImageError(true);
                                    setImageLoaded(true);
                                    }}
                                />
                            </Box>
                    }
                </Box>
            </Box>
        </>
    );
}
